//client/src/components/tiposContrato/TipoContratoForm.js
import React, { useState, useEffect } from 'react';
import { useMutateTiposContrato } from '../../hooks/useTiposContrato';
import { useAuth } from '../../hooks/useAuth'; // Importar useAuth
import { isMatrizAdmin as checkIsMatrizAdmin } from '../../utils/permissions';
import { XCircle } from 'lucide-react';
import { FormStepper, FormStepNavigation } from '../shared/FormStepper';

const STEP_LABELS = ['Informações do Tipo de Contrato'];

const initialState = { nome: '', codigo: '', descricao: '', ativo: true, isPadrao: false };

const TipoContratoForm = ({ current, onCloseForm, onSaveSuccess }) => {
    const { user } = useAuth(); // Obter usuário
    const { addTipoContrato, updateTipoContrato, isPending: loading } = useMutateTiposContrato();
    const [tipo, setTipo] = useState(initialState);

    const isMatrizAdmin = checkIsMatrizAdmin(user) && !user?.account && !user?.franquia;

    useEffect(() => { 
        if (current) {
            setTipo(current); 
        } else {
            setTipo(initialState); 
        }
    }, [current]);

    const onChange = e => {
        const { name, value, type, checked } = e.target;
        setTipo(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };
    
    const onSubmit = e => {
        e.preventDefault();
        
        const payload = { ...tipo };
        if (!isMatrizAdmin) {
            delete payload.isPadrao;
        }

        if (current) {
            updateTipoContrato.mutate({ id: current._id, tipoContratoData: payload }, {
                onSuccess: onSaveSuccess
            });
        } else {
            addTipoContrato.mutate(payload, {
                onSuccess: onSaveSuccess
            });
        }
    };

    return (
        <form onSubmit={onSubmit} noValidate>
            <div className="form-header">
                <h3 className="form-title">{current ? `Editar Tipo de Contrato: ${tipo.nome}` : 'Novo Tipo de Contrato'}</h3>
                <button type="button" onClick={onCloseForm} title="Fechar" className="form-close-button"><XCircle size={24} /></button>
            </div>

            <FormStepper currentStep={1} steps={STEP_LABELS} />

            <fieldset className="form-section" disabled={loading}>
                <legend className="form-section-title">Informações do Tipo de Contrato</legend>
                <div className="form-grid-container">
                    <div className="form-group">
                        <label htmlFor="nome">Nome*</label>
                        <input type="text" id="nome" name="nome" value={tipo.nome} onChange={onChange} required className="form-input"/>
                    </div>
                    <div className="form-group">
                        <label htmlFor="codigo">Código*</label>
                        <input type="text" id="codigo" name="codigo" value={tipo.codigo} onChange={onChange} required className="form-input" placeholder="Ex: SERV-001"/>
                    </div>
                    <div className="form-group full-width">
                        <label htmlFor="descricao">Descrição</label>
                        <textarea id="descricao" name="descricao" value={tipo.descricao} onChange={onChange} rows="3" className="form-input"/>
                    </div>
                    {isMatrizAdmin && (
                        <div className="form-group-checkbox full-width">
                            <input type="checkbox" name="isPadrao" id="isPadrao" checked={tipo.isPadrao || false} onChange={onChange} />
                            <label htmlFor="isPadrao">Este é um tipo de contrato Padrão Global</label>
                        </div>
                    )}
                </div>
            </fieldset>

            <div className="form-actions">
                <button type="button" onClick={onCloseForm} className="action-button action-button-secondary">
                    <XCircle size={18} className="icon"/>Cancelar
                </button>
                <FormStepNavigation
                    currentStep={1}
                    totalSteps={1}
                    onBack={() => {}}
                    onNext={() => {}}
                    isSubmitting={loading}
                    submitLabel={current ? 'Atualizar' : 'Salvar'}
                />
            </div>
        </form>
    );
};

export default TipoContratoForm;